import type {
    ShippingOption,
    ShippingProduct
} from 'tradera/state/services/types/webapi-selling-generated';
import {
    mapToDecoratedShippingProduct,
    type DecoratedShippingProduct
} from '../shipping-reducer';

const getTakeawayOption = (isTakeawayOnly: boolean) => {
    return isTakeawayOnly
        ? {
              type: 'TakeawayOnly',
              providerId: 'TakeawayOnly',
              name: 'Endast avhämtning'
          }
        : {
              type: 'Takeaway',
              providerId: 'Takeaway',
              name: 'Avhämtning'
          };
};

export const getSelectedShippingProducts = (
    shippingProducts: DecoratedShippingProduct[],
    selectedShippingOptions: DecoratedShippingProduct[],
    offerTakeaway: boolean
): DecoratedShippingProduct[] => {
    const result: DecoratedShippingProduct[] = selectedShippingOptions
        .map((selected) => {
            const shippingOption = shippingProducts.find((product) => {
                if (!selected.providerId || !selected.weight) {
                    return product?.providerId === selected.providerId;
                }

                return (
                    product?.providerId === selected.providerId &&
                    product?.weight === selected.weight &&
                    product?.id === selected.id
                );
            });

            if (!shippingOption) return null;

            return !!selected.isShippingFreeBasedOnCharity ===
                !!shippingOption.isShippingFreeBasedOnCharity
                ? {
                      ...shippingOption,
                      cost: selected.cost
                  }
                : {
                      ...shippingOption,
                      cost: selected.cost
                  };
        })
        .filter((x) => x !== null);
    if (offerTakeaway) {
        const takeAwayOption = getTakeawayOption(result.length === 0);
        result.push(
            mapToDecoratedShippingProduct(
                takeAwayOption as unknown as ShippingProduct
            )
        );
    }

    return result;
};

export const getSelectedShippingOptions = (
    shippingProducts: DecoratedShippingProduct[],
    selectedShippingOptions: ShippingOption[],
    offerTakeaway: boolean
) => {
    const result: DecoratedShippingProduct[] = selectedShippingOptions
        .map((selected) => {
            const shippingOption = shippingProducts.find((product) => {
                if (!selected.type || !selected.weight) {
                    return product?.providerId === selected.type;
                }

                return (
                    product?.providerId === selected.type &&
                    product?.weight === selected.weight &&
                    product?.id === selected.productId
                );
            });

            if (!shippingOption) return null;

            return {
                ...shippingOption,
                cost: selected.cost ?? null
            };
        })
        .filter((x) => x !== null);

    if (offerTakeaway) {
        const takeAwayOption = getTakeawayOption(result.length === 0);
        result.push(
            mapToDecoratedShippingProduct(
                takeAwayOption as unknown as ShippingProduct
            )
        );
    }

    return result.filter((x) => x !== null);
};
